import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoListBoxMixin from './KendoListBoxMixin'

export default {
    name: 'kendo-listbox',
    mixins: [ KendoListBoxMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('select', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-listbox-vue-wrapper/src/KendoListBox/index.js